var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Menu'),_c('Sidebar'),_c('section',{staticClass:"agem_main"},[_c('div',{staticClass:"main"},[_c('router-view')],1)]),_c('ModalTerms'),_c('PortalTarget',{attrs:{"name":"modals"}}),_c('Success'),_c('Error')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }